import { IFilterModel, IListModel } from 'shared/models/List'
import { MeetingStatusEnum } from './BoardMeeting'

export interface IBoardCasesList extends IListModel {
  result: IBoardCase[]
}
export type BoardCasesDropdownValueTypes =
  | 'Aktive saker'
  | 'Behandlet'
  | 'Alle'
  | 'Utsatte saker'
  | 'Saker til oppfølging'
export type SilentUpdateTypes = 'description' | 'suggestedDecision'
export type CaseAttachmentResultType = 'tookTooLong' | 'success'

export enum BoardCaseTypeEnum {
  DecisionCase = 'DecisionCase',
  OrientationCase = 'OrientationCase',
  FollowUpCase = 'FollowUpCase',
  FixedCase = 'FixedCase',
}

export enum BoardCaseStatusEnum {
  New = 'New',
  Completed = 'Completed',
  Ongoing = 'Ongoing',
  Deleted = 'Deleted',
  ForFollowup = 'ForFollowup',
  Postponed = 'Postponed',
}

export enum CasesQueryStatusEnum {
  ActiveCases = 'ActiveCases',
  Completed = 'Completed',
  All = 'All',
  Deleted = 'Deleted',
  ActiveCasesThatCanBeAddedToMeeting = 'ActiveCasesThatCanBeAddedToMeeting',
  NewCasesThatCanBeAddedToMeeting = 'NewCasesThatCanBeAddedToMeeting',
  ForFollowupCasesThatCanBeAddedToMeeting = 'ForFollowupCasesThatCanBeAddedToMeeting',
  PostponedCasesThatCanBeAddedToMeeting = 'PostponedCasesThatCanBeAddedToMeeting',
  New = 'New',
  Ongoing = 'Ongoing',
  ForFollowup = 'ForFollowup',
  Postponed = 'Postponed',
}

export enum FinishCaseStatusEnum {
  Complete = 1,
  Followup = 2,
  Postpone = 3,
}

export enum CasesSortColumnEnum {
  Title = 'title',
  Created = 'created',
  Status = 'status',
  CaseType = 'caseType',
  Responsible = 'responsible',
  Deadline = 'deadline',
}

export enum CaseItemActionEnum {
  RemoveCase = 'removeCase',
  ConnectToMeeting = 'connectToMeeting',
  AddAttachment = 'addAttachment',
  RecoverCase = 'recoverCase',
}

export interface IUpdateSharedWithModel {
  shareWithBbl: boolean
  meetingId: string
}

interface IBoardCaseBaseModel {
  caseType: BoardCaseTypeEnum
  title: string
  description: string
  submittedBy: string
  deadline?: Date
  suggestedDecision: string
  links: string[]
}

export interface IBoardCase
  extends Omit<IBoardCaseBaseModel, 'suggestedDecision' | 'links'> {
  id: string
  created: Date
  deadline?: Date
  status: BoardCaseStatusEnum
  responsible?: IBoardCasePerson
  meetingId?: string
  meetingTime?: Date
  lastUpdated?: Date
}

export interface IBoardCaseFilter
  extends Omit<IFilterModel, 'sortcolumn' | 'sortorder'> {
  clientId: string
  sortColumn: CasesSortColumnEnum
  sortOrder: string
  take: number
  skip: number
  queryStatus: CasesQueryStatusEnum
  searchStatus: string
}

export type ProposedForEditCaseFilterType = 'all' | 'postponed' | 'followup'
export enum ProposedForEditCaseFilterEnum {
  all = 'Vis Alle',
  postponed = 'Tidligere utsatte',
  followup = 'Saker til oppfølging',
}

type BoardCaseFilterBase = Omit<IBoardCaseFilter, 'clientId'>
// Add prop 'caseStatus' to BoardCaseFilterBase
export type ProposedForEditFilter = BoardCaseFilterBase & {
  caseStatus: ProposedForEditCaseFilterType
}

export interface IConnectCaseToMeetingModel {
  meetingId: string
  caseId: string
}

export interface IBoardCasePerson {
  fullName: string
  id: string
}

export interface IBoardCasePostModel extends IBoardCaseBaseModel {
  clientId: string
  responsibleNameId?: string
  connectedMeetingId?: string | null
}

export interface ICasePutModel extends IBoardCaseBaseModel {
  responsibleNameId: string
  lastUpdated?: Date
  connectedMeetingId?: string | null
}

export interface IBoardCaseDetailModel
  extends Omit<IBoardCaseBaseModel, 'links'> {
  id: string
  connectedMeeting?: IConnectedMeetingModel | null
  connectedMeetings?: IConnectedMeetingModel[]
  responsible: IBoardCasePerson | null
  caseStatus: BoardCaseStatusEnum
  caseNumber?: number
  decisions: IBoardCaseDecisionModel[]
  lastUpdated?: Date
  links: IBoardCaseLinks[]
  inboxMessageModel?: IMessageCase
}

export interface IBoardCaseInputModel
  extends Omit<IBoardCaseDetailModel, 'links'> {
  links: string[]
  link: string
  archiveFileIds?: string[]
}

export interface IBoardCaseDecisionModel {
  procotolNumber: number
  decisionText: string
  decisionDate: Date
  meeting: IConnectedMeetingModel
}

export interface IBoardCaseAttachmentModel {
  id: string
  filename: string
  contentType: string
  isArchiveFile: boolean
  isExisting: boolean
  file?: File
}

export interface IConnectedMeetingModel {
  id: string
  title: string
  status: MeetingStatusEnum
}

export interface ILinkModel {
  link: string
  id: string
}

export interface IDeleteCaseModel extends ICaseLastUpdatedModel {
  id: string
  deleted: boolean
}

// Update one of the suggested or description
export interface ICasePutDecisionModel extends ICaseLastUpdatedModel {
  suggestedDecision?: string
  description?: string
}

export interface ICaseLastUpdatedModel {
  lastUpdated?: Date
}

export interface IBoardCaseLinks {
  link: string
  isLinkToInboxMessage: boolean
}

export interface IMessageCase {
  inboxMessageId: string
  messageType: string
}

export interface IAutosaveCase {
  type: SilentUpdateTypes
  text: string
}

export interface IBoardCreateCaseRequestModel {
  body: IBoardCaseInputModel
  addToAgenda: boolean
  inboxCaseProps?: {
    isSms: boolean
    isProcessedFolder: boolean
    redirect: string
  }
  archiveFileIds?: string[]
}

export interface IUpdateCaseInList {
  id: string
  status: BoardCaseStatusEnum
}
